import Vue from 'vue'
import App from './App.vue'
import router from './router'
import 'element-ui/lib/theme-chalk/index.css'
import '@/styles/design-system.scss'
import '@/styles/mobile-h5.scss'

import Button from 'element-ui/lib/button'
import Card from 'element-ui/lib/card'
import Carousel from 'element-ui/lib/carousel'
import CarouselItem from 'element-ui/lib/carousel-item'
import Checkbox from 'element-ui/lib/checkbox'
import Col from 'element-ui/lib/col'
import DatePicker from 'element-ui/lib/date-picker'
import Descriptions from 'element-ui/lib/descriptions'
import DescriptionsItem from 'element-ui/lib/descriptions-item'
import Dialog from 'element-ui/lib/dialog'
import Divider from 'element-ui/lib/divider'
import Drawer from 'element-ui/lib/drawer'
import Form from 'element-ui/lib/form'
import FormItem from 'element-ui/lib/form-item'
import Image from 'element-ui/lib/image'
import Input from 'element-ui/lib/input'
import InputNumber from 'element-ui/lib/input-number'
import Link from 'element-ui/lib/link'
import Menu from 'element-ui/lib/menu'
import MenuItem from 'element-ui/lib/menu-item'
import Option from 'element-ui/lib/option'
import Pagination from 'element-ui/lib/pagination'
import RadioButton from 'element-ui/lib/radio-button'
import RadioGroup from 'element-ui/lib/radio-group'
import Row from 'element-ui/lib/row'
import Select from 'element-ui/lib/select'
import Switch from 'element-ui/lib/switch'
import TabPane from 'element-ui/lib/tab-pane'
import Table from 'element-ui/lib/table'
import TableColumn from 'element-ui/lib/table-column'
import Tabs from 'element-ui/lib/tabs'
import Tag from 'element-ui/lib/tag'
import Tooltip from 'element-ui/lib/tooltip'
import Upload from 'element-ui/lib/upload'
import Loading from 'element-ui/lib/loading'
import Message from 'element-ui/lib/message'
import MessageBox from 'element-ui/lib/message-box'

const components = [
  Button, Card, Carousel, CarouselItem, Checkbox, Col, DatePicker,
  Descriptions, DescriptionsItem, Dialog, Divider, Drawer, Form, FormItem,
  Image, Input, InputNumber, Link, Menu, MenuItem, Option, Pagination,
  RadioButton, RadioGroup, Row, Select, Switch, TabPane, Table, TableColumn,
  Tabs, Tag, Tooltip, Upload
]

components.forEach(component => Vue.use(component))
Vue.use(Loading.directive)

Vue.prototype.$loading = Loading.service
Vue.prototype.$message = Message
Vue.prototype.$msgbox = MessageBox
Vue.prototype.$alert = MessageBox.alert
Vue.prototype.$confirm = MessageBox.confirm
Vue.prototype.$prompt = MessageBox.prompt

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
